// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p.modal-create-info-text {
    font-size: medium;
    margin-block: 0.2em;
}

.edit-modal input {
    font-size: medium;
    border-color: rgba(0,0,0,.3);
    border-radius: 5px;
    border-width: 1px;
    line-height: 1.4;
}

.edit-modal textarea {
    font-size: medium;
    border-color: rgba(0,0,0,.3);
    border-radius: 5px;
    border-width: 1px;
    line-height: 1.2;
}

.floating-footer {
    position: -webkit-sticky;
    position: sticky; 
    bottom: -20px;
    left: 0;
    height: 40px;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    background-color: rgba(255,255,255,0.6);
}`, "",{"version":3,"sources":["webpack://./src/css/modal.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,4BAA4B;IAC5B,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,4BAA4B;IAC5B,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,wBAAgB;IAAhB,gBAAgB;IAChB,aAAa;IACb,OAAO;IACP,YAAY;IACZ,0BAAkB;IAAlB,uBAAkB;IAAlB,kBAAkB;IAClB,uCAAuC;AAC3C","sourcesContent":["p.modal-create-info-text {\n    font-size: medium;\n    margin-block: 0.2em;\n}\n\n.edit-modal input {\n    font-size: medium;\n    border-color: rgba(0,0,0,.3);\n    border-radius: 5px;\n    border-width: 1px;\n    line-height: 1.4;\n}\n\n.edit-modal textarea {\n    font-size: medium;\n    border-color: rgba(0,0,0,.3);\n    border-radius: 5px;\n    border-width: 1px;\n    line-height: 1.2;\n}\n\n.floating-footer {\n    position: sticky; \n    bottom: -20px;\n    left: 0;\n    height: 40px;\n    width: fit-content;\n    background-color: rgba(255,255,255,0.6);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
